import { render, staticRenderFns } from "./pointsMXListShare.vue?vue&type=template&id=359e26b5&scoped=true&"
import script from "./pointsMXListShare.vue?vue&type=script&lang=ts&"
export * from "./pointsMXListShare.vue?vue&type=script&lang=ts&"
import style0 from "./pointsMXListShare.vue?vue&type=style&index=0&id=359e26b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359e26b5",
  null
  
)

export default component.exports